// collapses stray extra "." / "," down to a single decimal separator and strips leading zeros
// (e.g. "0100" or "0...123..123") - numberInputFormatter neither dedupes separators nor strips
// leading zeros, and parseFloat silently truncates a string with more than one "." to whatever
// precedes the second one (e.g. "0...123" -> 0), which lets malformed input slip past any
// downstream clamp that only checks the parsed numeric value
export const sanitizeNumberInput = (raw) => {
	let str = raw.replace(/[^-0-9.,]/g, '')
	const negative = str[0] === '-'
	str = str.replace(/-/g, '')
	const sepIndex = str.search(/[.,]/)
	if(sepIndex !== -1) {
		str = str.slice(0, sepIndex).replace(/[.,]/g, '') + '.' + str.slice(sepIndex + 1).replace(/[.,]/g, '')
	}
	str = str.replace(/^0+(?=\d)/, '')
	return (negative ? '-' : '') + str
}

export const numberInputFormatter = (val) => {
	let str = val.replace(/[^-0-9.,]/g, '')
	str = (str[0] === '-' ? '-' : '') + str.replace(/-/g, '')
	str = str.replace(',', '.')
	// group only the integer part with thousand separators - grouping the decimal part too (e.g.
	// "77.1875" -> "77.1 875") produces a string the backend can't parse as a number
	const dotIndex = str.indexOf('.')
	const integerPart = dotIndex === -1 ? str : str.slice(0, dotIndex)
	const rest = dotIndex === -1 ? '' : str.slice(dotIndex)
	return integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, " ") + rest
}

export const numberStringToNumber = (val) => {
	if(!val) return 0
	return Number(val.toString().replace(/[^-0-9.,]/g, '').replace(',', '.'))
}

export const roundToTwoDecimals = (num) => {
	return Math.round(num * 100) / 100
}
